import { Box, Container, Grid, Typography, Paper } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import BrushIcon from "@mui/icons-material/Brush";
import SpeedIcon from "@mui/icons-material/Speed";

const skills = [
  {
    icon: <CodeIcon sx={{ fontSize: 40 }} />,
    title: "Development",
    description: "ReactJs, JavaScript, TypeScript, HTML5, CSS3, NodeJs, MUI, Shopify Liquid Template",
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: "Performance",
    description: "Web Performance Optimization, SEO, Responsive Design, Best Practices",
  },
  {
    icon: <BrushIcon sx={{ fontSize: 40 }} />,
    title: "Tools & Collaboration",
    description: "GitHub, Figma, Jira, Notion, Slack",
  },
  
];

function About() {
  return (
    <Box
      sx={{
        py: 12,
        backgroundColor: "background.paper",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            mb: 8,
            color: "primary.main",
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: "-16px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "60px",
              height: "4px",
              backgroundColor: "primary.main",
            },
          }}
        >
          About Me
        </Typography>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/Headshot.jpeg"
              alt="Profile"
              sx={{
                width: "100%",
                height: "400px",
                objectFit: "cover",
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" sx={{ mb: 3 }}>
              Turning Ideas into Reality
            </Typography>
            <Typography
              variant="body1"
              sx={{ mb: 3, color: "text.secondary", lineHeight: 1.8 }}
            >
              I'm a passionate frontend engineer with a keen eye for design and a
              commitment to creating intuitive user experiences. With expertise in
              modern web technologies and a problem-solving mindset, I bring ideas
              to life through clean, efficient code.
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "text.secondary", lineHeight: 1.8 }}
            >
              Outside my career, I’m deeply passionate about personal development, focusing on career growth and financial wellness. 
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          {skills.map((skill, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: "100%",
                  backgroundColor: "background.default",
                  border: "1px solid",
                  borderColor: "primary.main",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                }}
              >
                <Box sx={{ color: "primary.main", mb: 2 }}>{skill.icon}</Box>
                <Typography variant="h5" sx={{ mb: 2 }}>
                  {skill.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {skill.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default About;